import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/documents.js';
import q from '../query.js';
export const documentsEntity = 'documents';
export const documentsByReferenceKey = (referenceId) => `documents-by-reference-${referenceId}`;
export const useDocumentsByReference = (referenceId, casualConsistency) => q.query(documentsByReferenceKey(referenceId), () => api.get(referenceId), keys.read.collection(documentsEntity), { enabled: referenceId != null });
// The type and dates of a case's documents that extend limitation: all the
// economy calculations read. Debtors and creditors may not see the documents
// themselves, so every role calculates from this.
export const useLimitationDocuments = (caseId) => q.query(`limitation-documents-${caseId}`, () => api.getLimitation(caseId), keys.read.collection(documentsEntity), { enabled: caseId != null });
//# sourceMappingURL=index.js.map